import { useEffect, useState } from "react";
import styled from "styled-components";
import { AnimatePresence, motion } from "motion/react";

const SEEN_KEY = "desktop-tip-seen";
const SHOW_AFTER_MS = 7000;
const HIDE_AFTER_MS = 14000;

// XP-style notification balloon that pops out of the tray once per session
const TrayBalloon = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(SEEN_KEY)) return;
    } catch {
      // storage blocked: just show the tip
    }
    const show = setTimeout(() => {
      setVisible(true);
      try {
        sessionStorage.setItem(SEEN_KEY, "1");
      } catch {}
    }, SHOW_AFTER_MS);
    const hide = setTimeout(
      () => setVisible(false),
      SHOW_AFTER_MS + HIDE_AFTER_MS
    );
    return () => {
      clearTimeout(show);
      clearTimeout(hide);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <Balloon
          initial={{ opacity: 0, y: 12, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ type: "spring", stiffness: 300, damping: 22 }}
          onClick={() => setVisible(false)}
        >
          <Header>
            <InfoIcon>i</InfoIcon>
            <b>Did you know?</b>
            <Close aria-label="Close tip">×</Close>
          </Header>
          <p>
            Right-click any project for screenshots and details. Open{" "}
            <b>Computer</b> to browse everything, or right-click the desktop to
            change the wallpaper.
          </p>
        </Balloon>
      )}
    </AnimatePresence>
  );
};

export default TrayBalloon;

const Balloon = styled(motion.div)`
  position: absolute;
  right: 4px;
  bottom: calc(100% + 14px);
  width: 270px;
  padding: 8px 10px 10px;
  background: #ffffe1;
  border: 1px solid #000;
  border-radius: 8px;
  box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
  font-size: 12px;
  line-height: 1.4;
  cursor: pointer;
  transform-origin: bottom right;

  /* the little tail pointing at the tray */
  &::after {
    content: "";
    position: absolute;
    right: 30px;
    bottom: -12px;
    border-width: 12px 0 0 14px;
    border-style: solid;
    border-color: #000 transparent transparent transparent;
  }
  &::before {
    content: "";
    position: absolute;
    right: 31px;
    bottom: -10px;
    border-width: 11px 0 0 12px;
    border-style: solid;
    border-color: #ffffe1 transparent transparent transparent;
    z-index: 1;
  }

  & p {
    margin-top: 4px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const InfoIcon = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1f5fd6;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  font-style: italic;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: Georgia, serif;
`;

const Close = styled.span`
  margin-left: auto;
  font-size: 16px;
  line-height: 1;
  color: #404040;
`;
